<template>
  <van-popup
    v-model="visible"
    get-container="body"
    :close-on-click-overlay="false"
    style="background-color: transparent; overflow-y: visible"
    @close="$emit('close')"
    @closed="$emit('closed')"
    @open="$emit('open')"
    @opened="$emit('opened')"
  >
    <div :class="[$style.popup, $style[`popup-${size}`]]">
      <btn-close @click="visible = false" :class="$style['btn-close']" />
      <slot />
    </div>
  </van-popup>
</template>

<script>
import BtnClose from '../BtnClose'

export default {
  name: 'PopupFrame',
  components: { BtnClose },
  props: {
    /**
     * 弹窗尺寸
     * @values mini, sm, md, lg
     */
    size: { type: String, default: 'sm' }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style lang="less" module>
.popup {
  color: #fff;
  font-size: 0.28rem;

  em {
    color: #fee493;
  }

  .btn-close {
    position: absolute;
    top: -0.85rem;
    right: 0.4rem;
  }

  &-mini {
    .size(7.13rem, 4.76rem);
    .background-fill('./images/bg-mini.png');

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0.24rem 0 0.34rem;

    em {
      color: #fee493;
    }

    .btn-close {
      position: absolute;
      top: -0.6rem;
      right: 0.25rem;
    }
  }

  &-sm {
    .size(7.28rem, 5.79rem);
    .background-fill('./images/bg-sm.png');

    padding: 1.1rem 0.7rem 0.25rem 0.55rem;
  }

  &-md {
    .size(7.46rem, 6.59rem);
    .background-fill('./images/bg-md.png');

    padding: 1.5rem 0.53rem 0.25rem 0.54rem;
  }

  &-lg {
    .size(7.5rem, 8.09rem);
    .background-fill('./images/bg-lg.png');

    padding: 1.2rem 0.53rem 0.25rem 0.54rem;
  }
}
</style>
